/**
 * BuildLogic Google Analytics (GA4) shared config.
 * All apps should send to the same property so Morning Metrics can aggregate.
 * Property ID is read from env (EMPIRE_GA_PROPERTY_ID or GA_PROPERTY_ID); store in .env.local (gitignored).
 */

/**
 * BuildLogic GA4 property ID (numeric). Read from env only; do not hardcode.
 * Set EMPIRE_GA_PROPERTY_ID (or GA_PROPERTY_ID) in .env.local or GitHub Actions secrets.
 */
export function getEmpireGaPropertyId(): string | undefined {
  if (typeof process === 'undefined' || !process.env) return undefined;
  return (
    process.env.EMPIRE_GA_PROPERTY_ID ||
    process.env.GA_PROPERTY_ID ||
    undefined
  );
}

/**
 * Get the GA4 Measurement ID (G-...) for client-side gtag.
 * Set NEXT_PUBLIC_GA_MEASUREMENT_ID or VITE_GA_MEASUREMENT_ID to the value
 * from GA4 Admin → Data Streams → your Web stream for the BuildLogic property.
 */
export function getGaMeasurementId(): string | undefined {
  if (typeof process === 'undefined' || !process.env) return undefined;
  return (
    process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ||
    process.env.VITE_GA_MEASUREMENT_ID ||
    undefined
  );
}
